var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorfulEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72656 18.909C8.72656 16.4991 10.6802 14.5454 13.0902 14.5454H43.6357V18.909H8.72656Z",
    fill: "#0ED6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0898 45.0908H40.7262V49.4545H13.0898V45.0908Z",
    fill: "#117BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7266 45.0908H49.4538V49.4545H40.7266V45.0908Z",
    fill: "#01AAE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9102 14.5454C53.3201 14.5454 55.2738 16.4991 55.2738 18.909L55.2738 43.6363H50.9102L50.9102 14.5454Z",
    fill: "#13E0F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0902 49.4546C10.6802 49.4546 8.72656 47.501 8.72656 45.091L8.72656 34.9092L13.0902 34.9092L13.0902 49.4546Z",
    fill: "#01AAE0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.6367,
    y: 14.5454,
    width: 7.27273,
    height: 4.36364,
    fill: "#0CC4E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72656 18.9092H13.0902V34.9092H8.72656V18.9092Z",
    fill: "#0092C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7152 23.273L35.0851 37.642L34.0565 38.6706C32.9205 39.8066 31.0786 39.8067 29.9425 38.6707L14.543 23.2729L20.7152 23.273Z",
    fill: "#0ED6E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1864 30.3692L31.9988 34.5568L35.0851 37.642L39.272 33.4548L36.1864 30.3692Z",
    fill: "#01AAE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2807 23.2738L36.1836 30.3713L39.2692 33.4569L49.4529 23.2738H43.2807Z",
    fill: "#117BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulEnvelope);
export default __webpack_public_path__ + "static/media/ColorfulEnvelope.f0535560155c4591af127603ba40df06.svg";
export { ForwardRef as ReactComponent };